import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Oi, pessoal! Eu sou <span className="purple">Luiz</span> de{" "}
            <span className="purple">Montes Claros, Minas Gerais.</span>
            <br />
            Sou desenvolvedor full stack, trabalho com React.js, Node.js, Java,
            TypeScript e PostgreSQL.
            <br />
            Gosto de criar sistemas inteligentes, automatizar processos e
            transformar ideias em soluções reais através do código.
            <br />
            <br />
            Além da programação, aqui estão algumas coisas que eu adoro fazer:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Jogar 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Gravar videos sobre tecnologia e marketing digital 🔄
            </li>
            <li className="about-activity">
              <ImPointRight /> Aprender coisas novas constantemente 📚
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Nem sempre dá certo, mas sempre é do caralho tentar."
          </p>
          <footer className="blockquote-footer">Luiz Developer</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
